export default __webpack_public_path__ + "static/media/risk.a06a2b52.png";